// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  VERSION: require('../../package.json').version,
  // Тип авторизации (esiaAuthenticated - Боевая авторизация ЕСИА, loginAuthenticated - Авторизация по логин + пароль)
  authType: 'loginAuthenticated',
  // Ссылка на сервис авторизации ЕСИА
  authUrl: 'http://eis-mioro.donland.ru:8881/api/signin',
  // Ссылка на внешний сервис взаимодействия
  serviceUrl: 'http://srv-saumi-kilo:19080/ws/tpo/',
  // Настройки сайта
  site: {
    // Заголовок
    title: '',
    // Ссылка на логотип, оставить пустым чтобы скрыть
    logo_url: '',
    // Ссылка favicon, оставить пустым чтобы скрыть
    favicon_url: '',
    // Ссылка на "правила использования", оставить пустым чтобы скрыть
    agreement_link: 'javascript:void(0);',
    // Ссылка на "соглашение об уведомлении", оставить пустым чтобы скрыть
    notification_link: 'javascript:void(0);',
    // Прямая ссылка для "Оплата онлайн", оставить пустым чтобы скрыть кнопку
    online_pay_link: '',
    // Отображать кнопку "Связь"
    button_communication: true,
    // Отображать ссылку "АКТ СВЕРКИ РАСЧЕТОВ"
    act_reconsilation_link: true,
    // Отображать ссылку "ЗАДАТЬ ВОПРОС ПО ДОГОВОРУ"
    ask_question_link: true,
    // Отображать кнопку "ИЗМЕНИТЬ" в контактной информации
    button_change_contact: true,
    // Отображать документы в карточке договора 
    show_documents_tab_contract: true,
    // Приветственный текст
    main_page_text_title: `Приветствуем Вас на портале<br>Личный кабинет арендатора`,
    main_page_text: `Для входа используйте Вашу учетную запись в Единой системе идентификации и аутентификации (ЕСИА).`
  },
  // Настройка отображения уведомлений
  notification_options: {
    // Появлении задолженности
    arrears: true,
    // Наступлении срока оплаты
    paymentDeadline: true,
    // Формировании претензии
    formation: true,
    // Окончание договора
    terminationContract: true,
    // Получение сообщения
    receivingMessage: false,
    // Изменение арендной платы по договору
    obligation: true
  },
  // Настройка аттачей
  attachments: {
      // Максимальный размер файла в байтах
      fileSize: 1024000,
      // Список расширений доступных для загрузки
      extensions: [
        'pdf',
        'doc',
        'docx',
        'txt',
        'rtf',
        'xls',
        'xlsx',
        'jpg',
        'jpeg',
        'png'
      ]
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts